import tableSort from 'table-sort-js/table-sort.js';
